import React, { useMemo, useState } from "react";
import { CheckOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import autoLeasing from "assets/svg/autoLeasing.svg";
import personalFinance from "assets/svg/personalFinance.svg";
import { useTranslation } from "contexts/TranslationContext";
import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLazyGetBusinessProviderAltQuery } from "services/lookup";
import BackButton from 'shared/components/BackButton/BackButton';
import NoData from 'shared/components/NoData';
import routes, { appRoute } from 'shared/constants/routes';
import { Row, Col, Card, Button, Upload, Input, Form, Typography, Modal } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { FormDrawer, buildInitialValues, buildValidationSchema } from 'Components';
import * as Yup from "yup";
import { Formik, useFormikContext } from "formik";
import { useCreateNewAppMutation } from "services/auth";
import useAuthHook from "hooks/useAuthHook";
import { useUpdateAppDetailsMutation } from "services/auth";
import { toast } from "react-toastify";
import Arrow from 'assets/svg/arrow.svg'
import axios from "axios";
import env from "shared/constants/env";
import { useRef } from "react";
import SaudiRiyal from "assets/svg/saudi_riyal_symbol.svg";

// import SilverVoucher from "assets/svg/SilverVoucher.svg";
// import EmeraldVoucher from "assets/svg/EmeraldVoucher.svg";



const { Title, Text } = Typography;
const { Dragger } = Upload;

const user = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));
const isSaudiUser = user?.USER_ID?.toString().startsWith('1');

const FinanceProducts = () => {
    const { translate, language } = useTranslation();
    const [createNewApp, createNewAppStatus] = useCreateNewAppMutation();
    const [updateApplicationDetails, updateAppDetailsStatus] = useUpdateAppDetailsMutation();
    const { getUser } = useAuthHook();
    const navigate = useNavigate();
    const { id } = useParams()
    const [uploadFile, setUploadFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [isUploading, setIsUploading] = useState(false)
    const [tenureOptions, setTenureOptions] = useState([]);
    const [termsChecked, setTermsChecked] = useState(true);
    const [isTermsModalVisible, setIsTermsModalVisible] = useState(false);
    const [manufacturerList, setManufacturerList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [modelTypeList, setModelTypeList] = useState([]);
    const [dealerList, setDealerList] = useState([]);
    const [colorList, setColorList] = useState([]);
    const [conditionList, setConditionList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [loanReasonsOptions, setLoanReasonsOptions] = useState([]);
    const [autoLoanLoading, setAutoLoanLoading] = useState(false);
    const [ibanVerifyLoader, setIbanVerifyLoader] = useState(false)


    const [assetIds, setAssetIds] = useState([]);
    const [assetId, setAssetId] = useState(null)
    const formikRef = useRef(null);

    function generateYearArray(startYear) {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let year = startYear; year <= currentYear; year++) {
            years.push({ label: String(year), value: String(year) });
        }

        return years;
    }

    const APP_DETAILS_DTO_KEYS = ["IBAN", "gender", "maritalStatus", "nationality", "numberOfDependents", "title", "region", "city", "foodExpenses", "housingExpenses", "domesticWorkers", "educationExpenses", "healthCareExpenses", "commAndTransExpenses", "insuranceExpenses", "anyExpectedFutureExpense", "productId", "subproductId", "request_amount", "loanReason", "assetModelYear", "assetPrice", "downPayment", "ballonPayment", "dealerId", "colorId", "assetId", "salesRef", "tenure", "empCatId", "p_residentId", "qualificationId", "sectorId", "dateOfJoining", "lat", "long", "buildingNum", "streetName", "district_name", "additionalNum", "postCode", "pep", "beneficiary", "beneficiaryName", "relatedPartyBoolean", "partyId"];

    const filterObjectByKeys = (obj, keys) =>
        Object.keys(obj)
            .filter((key) => keys.includes(key))
            .reduce((data, key) => ({ ...data, [key]: obj[key] }), {});


    useEffect(() => {
        if (id === "2") {
            fetch(`${env.API_ENDPOINT}lookup/loan-reasons?status=A`)
                .then(res => res.json())
                .then(res => {
                    console.log(res)
                    setLoanReasonsOptions(res.payload.rows.map(row => ({
                        label: row.REASON,
                        value: String(row.REASONID),
                        labelAr: String(row.REASON_AR),
                    })));
                })
                .catch(() => {
                    toast.error('Failed to load loan reasons.');
                });
        }
    }, [])

    // useEffect(() => {
    //     //check for Personal Financing eligibility
    //     const user = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));
    //     if (id === '2' && user?.USER_ID && !user?.USER_ID?.toString().startsWith('1')) {
    //         toast.error('You are not eligible for Personal Financing.');
    //         navigate(appRoute(routes.HOME));
    //     }
    // }, [id, navigate, translate]);


    const autoLeaseDetails =
    {
        id: 1,
        title: translate("HOME.AUTO"),
        description: "HOME.AUTO_DESC",
        image: autoLeasing,
        route: 1,
        subDescription: "PRODUCTS.AUTO_DESC_SUB",
    }


    const personalFinanceDetails =
    {
        id: 2,
        title: translate("HOME.PERSONAL"),
        description: "HOME.PERSONAL_DESC",
        image: personalFinance,
        route: 2,
        subDescription: "PRODUCTS.PERSONAL_DESC_SUB",
    }



    const showTermsModal = () => {
        setIsTermsModalVisible(true);
    };

    const handleTermsOk = () => {
        setIsTermsModalVisible(false);
    };

    const handleTermsCancel = () => {
        setIsTermsModalVisible(false);
    };
    // const { values } = useFormikContext()

    const isArabic = language?.code === "ar" ? true : false;

    let isLoading = createNewAppStatus.isLoading || updateAppDetailsStatus.isLoading || autoLoanLoading;

    const autoLeaseSchema = ({ hideRequestedLoanAmount = true, tenureOptions = [], manufacturerList = [], modelList = [], modelTypeList = [], dealerList = [], colorList = [], conditionList = [], yearList = [] }) => [
        {
            type: "select",
            key: "tenure",
            label: "Tenure",
            required: true,
            options: tenureOptions,
            // value: 4,
            span: 24,
            validation: Yup.string()
                .required("CANNOT_BE_EMPTY")
        },

        {
            type: "number",
            key: "salesRef",
            label: "SalesRef",
            span: 24,
            max: 10,
            min: 8,
            maxLength: 10,
            minLength: 8,
            required: false,
            validation: Yup.string()
                .matches(/^\d{8,10}$/, "MUST_BE_BETWEEN_8_AND_10_DIGITS")
        },

        {
            type: "select",
            key: "assetManufacturer",
            label: "Asset_manufacturer",
            searchable: true,
            span: 24,
            options: manufacturerList,
            required: true,
            validation: Yup.string().required("CANNOT_BE_EMPTY"),
        },
        {
            type: "select",
            key: "assetModel",
            label: "Asset_model",
            searchable: true,
            span: 24,
            options: modelList,
            required: true,
            validation: Yup.string().required("CANNOT_BE_EMPTY"),
        },
        {
            type: "select",
            key: "assetModelType",
            label: "Asset_model_type",
            searchable: true,
            span: 24,
            options: modelTypeList,
            required: true,
            validation: Yup.string().required("CANNOT_BE_EMPTY"),
        },
        {
            type: "select",
            key: "colorId",
            label: "Asset_color",
            span: 24,
            options: colorList,
            required: true,
        },
        {
            type: "select",
            key: "assetCondition",
            label: "Asset_condition",
            span: 24,
            required: true,
            options: conditionList,
            validation: Yup.string().required("CANNOT_BE_EMPTY"),

        },
        {
            type: "number",
            key: "assetPrice",
            label: "Asset_price",
            span: 24,
            required: true,
            validation: Yup.number().integer("MUST_BE_INTEGER").min(25000, "MUST_BE_ATLEAST").max(9999999, "CANNOT_EXCEED_7"),
        },
        {
            type: "select",
            key: "assetModelYear",
            label: "Asset_model_year",
            span: 24,
            required: true,
            options: yearList,
            validation: Yup.string().required("CANNOT_BE_EMPTY"),
        },
        {
            type: "number",
            key: "downPayment",
            label: "Down_payment",
            span: 24,
            required: true,
            validation: Yup.number()
                .integer("MUST_BE_INTEGER")
                .test("is-less-than-20-percen", "DOWN_PAYMENT_20", function (value) {
                    const { assetPrice } = this.parent;
                    return value === 0 || (value >= 3000 && value < assetPrice * 0.2);
                })
                .required("DOWN_PAYMENT_REQUIRED"),
        },
        {
            type: "number",
            key: "ballonPayment",
            label: "Ballon_payment",
            span: 24,
            required: true,
            validation: Yup.number()
                .integer("MUST_BE_INTEGER")
                .test("is-less-than-20-percent", "BALLON_PAYMENT_40", function (value) {
                    const { assetPrice } = this.parent;
                    return value <= assetPrice * 0.4;
                })
                .required("BALLON_REQUIRED"),
        },
        {
            type: "select",
            key: "dealerId",
            label: "Dealer_name",
            span: 24,
            options: dealerList,
            required: true,
            validation: Yup.string().required("CANNOT_BE_EMPTY"),
        },
    ];

    const personalFinanceSchema = ({ hideRequestedLoanAmount = true, tenureOptions = [] }) => [
        {
            type: "number",
            key: "request_amount",
            label: "Requested_loan_amount",
            span: 24,
            required: !hideRequestedLoanAmount,
            disabled: hideRequestedLoanAmount,
            pattern: "^[0-9]*$",
            validation: Yup.number()
                .required("CANNOT_BE_EMPTY")
                .when([], (values, schema) => {
                    if (isSaudiUser) {
                        return schema.min(3000, "MUST_BE_ATLEAST_3000").max(500000, "CANNOT_EXCEED_500000");
                    } else {
                        return schema.min(5000, "MUST_BE_ATLEAST_5000").max(80000, "CANNOT_EXCEED_80000");
                    }
                })
        },
        {
            type: "select",
            key: "tenure",
            label: "Tenure",
            required: true,
            options: tenureOptions,
            // value: 4,
            span: 24,
            validation: Yup.string()
                .required("CANNOT_BE_EMPTY")
            // .when('request_amount', (request_amount, schema) => {
            //   if (request_amount >= 2500 && request_amount <= 5000) {
            //     return schema.test(
            //       'max1',
            //       'MAX_12_MONTHS',
            //       value => { return parseInt(value, 10) <= 4 }
            //     );
            //   } else if (request_amount >= 5001 && request_amount <= 20000) {
            //     return schema.test(
            //       'max2',
            //       'MAX_36_MONTHS',
            //       value => parseInt(value, 10) <= 8
            //     );
            //   } else if (request_amount >= 20001) {
            //     return schema.test(
            //       'max3',
            //       'MAX_60_MONTHS',
            //       value => parseInt(value, 10) <= 12
            //     );
            //   }
            //   return schema; // default case if none of the conditions are met
            // }),
        },
        // { type: "number", key: "IBAN", label: "IBAN", span: 20, translation: 'REQUEST_DETAILS.IBAN' },
        {
            type: "text",
            key: "IBAN",
            label: "IBAN",
            span: 24,
            addonBefore: "SA",
            props: {
                maxLength: 22,
            },
            required: !hideRequestedLoanAmount,
            disabled: hideRequestedLoanAmount,
            validation: Yup.string()
                .when(['productId', '$hideRequestedLoanAmount'], ([productId, hide], schema) => {
                    if (hideRequestedLoanAmount)
                        return schema.notRequired();


                    return schema.required("CANNOT_BE_EMPTY")
                        .length(22, "IBAN_22")
                        .matches(/^[A-Z0-9]+$/i, "IBAN_ALPHANUMERIC_ONLY");
                }
                )
        },
        {
            type: "select",
            key: "loanReason",
            label: "LOAN_REASON",
            span: 24,
            options: loanReasonsOptions,
            required: !hideRequestedLoanAmount,
            disabled: hideRequestedLoanAmount,
            validation: Yup.string()
                .when('productId', (productId, schema) => {
                    if (hideRequestedLoanAmount)
                        return schema.notRequired();

                    return schema.required("CANNOT_BE_EMPTY")
                })
        },

        {
            type: "number",
            key: "salesRef",
            label: "SalesRef",
            span: 24,
            required: false,
            max: 10,
            min: 8,
            maxLength: 10,
            minLength: 8,
            validation: Yup.string()
                .matches(/^\d{8,10}$/, "MUST_BE_BETWEEN_8_AND_10_DIGITS")
        },
    ];

    const TenureUpdater = (props) => {
        // const { values, setFieldValue } = useFormikContext();
        // console.log(props?.values?.request_amount)

        useEffect(() => {
            if (id === "1") {
                setAutoLoanLoading(true);
                setYearList(generateYearArray(2022));
                Promise.all([
                    fetch(env.API_ENDPOINT + 'lookup/manufacturer?status=A'),
                    fetch(env.API_ENDPOINT + 'lookup/dealers?status=A'),
                    fetch(env.API_ENDPOINT + 'lookup/colors?status=A'),
                ])
                    .then(([manufacturers, dealers, colors]) =>
                        Promise.all([manufacturers.json(), dealers.json(), colors.json()]))
                    .then(([manufacturers, dealers, colors]) => {
                        setManufacturerList(manufacturers?.payload?.rows?.map(({ MFID, MFNAME, MFNAME_AR }) => ({
                            label: String(MFNAME),
                            value: String(MFID),
                            labelAr: String(MFNAME_AR),
                        })));

                        setDealerList(dealers?.payload?.rows?.map(({ DEALERID, DEALER_NAME, DEALER_NAME_AR }) => ({
                            label: String(DEALER_NAME),
                            value: String(DEALERID),
                            labelAr: String(DEALER_NAME_AR),
                        })));

                        setColorList(colors?.payload?.rows?.map(({ COLORID, COLOR_NAME, COLOR_NAME_AR }) => ({
                            label: String(COLOR_NAME),
                            value: String(COLORID),
                            labelAr: String(COLOR_NAME_AR),
                        })))
                    })
                    .catch(() => {
                        toast.error('Could not load lookup.');
                    })
                    .finally(() => {
                        setAutoLoanLoading(false);
                    });
            }
        }, []);

        useEffect(() => {
            // props.setFieldValue('assetModel', '');
            setModelList([]);

            if (props?.values?.assetManufacturer) {
                fetch(env.API_ENDPOINT + `lookup/models-by-manufacturer?status=A&mfId=${props?.values?.assetManufacturer}`)
                    .then(models => models.json())
                    .then(models => {
                        setModelList(models?.payload?.rows?.map(({ ASSETMODELID, ASSETMODEL_NAME, ASSETMODEL_NAME_AR }) => ({
                            label: String(ASSETMODEL_NAME),
                            value: String(ASSETMODELID),
                            labelAr: ASSETMODEL_NAME_AR
                        })));
                    })
                    .catch(() => {
                        toast.error('Lookup failed: Models');
                    })
                    .finally(() => { });
            }
        }, [props?.values?.assetManufacturer]); // eslint-disable-line

        useEffect(() => {
            // props.setFieldValue('assetModelType', '');
            if (props?.values?.assetModel) {
                fetch(env.API_ENDPOINT + `lookup/model-types-by-model?modelId=${props?.values?.assetModel}`)
                    .then(models => models.json())
                    .then(models => {
                        setModelTypeList(models?.payload?.rows?.map(({ ASSETMODELTYPEID, ASSETMODELTYPE_NAME, ASSETMODELTYPE_NAME_AR }) => ({
                            label: String(ASSETMODELTYPE_NAME),
                            value: String(ASSETMODELTYPEID),
                            labelAr: ASSETMODELTYPE_NAME_AR
                        })));
                    })
                    .catch(() => {
                        toast.error('Lookup failed: Model Types');
                    })
                    .finally(() => { });
            }
        }, [props?.values?.assetModel]); // eslint-disable-line

        useEffect(() => {
            // props.setFieldValue('assetCondition', '');
            if (props?.values?.assetModelType) {
                fetch(env.API_ENDPOINT + `lookup/conditions-by-model-type?modelId=${props?.values?.assetModel}&modelTypeId=${props?.values?.assetModelType}`)
                    .then(conditions => conditions.json())
                    .then(conditions => {
                        setConditionList(conditions?.payload?.rows?.map(({ ASSETCONDITIONID, ASSETCONDITION_NAME, ASSETCONDITION_NAME_AR }) => ({
                            label: String(ASSETCONDITION_NAME),
                            value: String(ASSETCONDITIONID),
                            labelAr: ASSETCONDITION_NAME_AR
                        })));

                        setAssetIds(
                            conditions?.payload?.rows?.map(({ ASSETID, ASSETCONDITIONID }) => ({
                                ASSETCONDITIONID: String(ASSETCONDITIONID),
                                ASSETID: String(ASSETID),
                            }))
                        );
                    })
                    .catch(() => {
                        toast.error('Lookup failed: Asset Conditions');
                    })
                    .finally(() => { });
            }
        }, [props?.values?.assetModelType]); // eslint-disable-line

        useEffect(() => {
            const currentAsset = assetIds?.find(
                asset => asset?.ASSETCONDITIONID === String(props?.values?.assetCondition)
            );
            setAssetId(currentAsset?.ASSETID || null);

        }, [props.values, assetIds]);


        const tenureOpt = useMemo(() => {
            const amount = props.values?.request_amount;
            if (id === "2") { //if tawarruq then validation
                if (isSaudiUser) { //if user is Saudi
                    if (amount < 3000 || amount > 500000) return [];
                    if (amount <= 3400) return [{ value: '6', label: '6' }];
                    if (amount >= 3401 && amount <= 9999) return [{ value: '6', label: '6' }, { value: '12', label: '12' }];
                    if (amount >= 10000 && amount <= 25000) return [
                        { value: '6', label: '6' },
                        { value: '12', label: '12' },
                        { value: '24', label: '24' },
                        { value: '36', label: '36' }
                    ];
                    if (amount >= 25001) return [
                        { value: '6', label: '6' },
                        { value: '12', label: '12' },
                        { value: '24', label: '24' },
                        { value: '36', label: '36' },
                        { value: '48', label: '48' },
                        { value: '60', label: '60' }
                    ];
                }
                if (!isSaudiUser) { //if user is non-Saudi
                    if (amount < 5000 || amount > 80000) return [];
                    // if (amount <= 3400) return [{ value: '6', label: '6' }];
                    // if (amount >= 3401 && amount <= 9999) return [{ value: '6', label: '6' }, { value: '12', label: '12' }];
                    // if (amount >= 10000 && amount <= 25000) return [
                    //     { value: '6', label: '6' },
                    //     { value: '12', label: '12' },
                    //     { value: '24', label: '24' },
                    //     { value: '36', label: '36' }
                    // ];
                    // if (amount >= 25001) return [
                    //     { value: '6', label: '6' },
                    //     { value: '12', label: '12' },
                    //     { value: '24', label: '24' },
                    //     { value: '36', label: '36' },
                    //     { value: '48', label: '48' },
                    //     { value: '60', label: '60' }
                    // ];
                    if (amount >= 5000 && amount <= 80000) return [
                        { value: '6', label: '6' },
                        { value: '12', label: '12' },
                        { value: '24', label: '24' },
                        { value: '36', label: '36' }
                    ];
                }
            }
            else {
                return [
                    { value: "6", label: "6" },
                    { value: "12", label: "12" },
                    { value: "24", label: "24" },
                    { value: "36", label: "36" },
                    { value: "48", label: "48" },
                    { value: "60", label: "60" },
                ]
            }
            return [];
        }, [props.values?.request_amount]);

        let tenureSelectionCheck = tenureOpt.find(opt => opt.value === props.values?.tenure)
        if (tenureSelectionCheck === undefined && props.values?.tenure !== "") {
            props.setValues((prev) => ({
                ...prev,
                tenure: ""
            }))
        }

        setTenureOptions(tenureOpt);

        return null; // This component doesn't render anything directly, it is only for computational purposes only
    };

    const productAppSubmit = async (paramValues, appId, idbUserId) => {
        {
            const values = {
                ...filterObjectByKeys(
                    {
                        ...paramValues,
                        IBAN: paramValues.IBAN ? "SA" + paramValues?.IBAN : null,
                        ...(assetId && id == '1' ? { assetId: assetId } : {}), //assetId is not null and available
                    },
                    APP_DETAILS_DTO_KEYS
                ),
                productId: id === "1" ? '217' : '328',  //ijarah or tawarruq
                subproductId: id === "1" ? '250' : '329', //auto or commodity
                applStatus: 'S' //submitted
            };


            const response = await updateApplicationDetails({
                appId: appId,
                userWebId: idbUserId,
                source: 'WEB',
                details: values,
            });
            if (response.error) {
                console.log("Error in update application", response.error);
                toast.error("Error in creating application");
                return
            }
            if (response.data) {
                toast.success("Application Created Successfully");
                navigate(`/${routes.APP_ROOT}/${routes.CREATE_REQUEST}/${routes.CREATE_REQUEST_SUCCESS}/${appId}`, { replace: true });

            }
        }
    }

    const ProductAppCreate = async (values) => {
        try {
            const user = getUser();

            if (!user) return;

            if (values?.IBAN) { //iban verification first before creating app
                const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));
                try {
                    setIbanVerifyLoader(true)
                    const verificationResult = await fetch(`${env.API_ENDPOINT}app/iban_verification`, {
                        method: 'POST',
                        headers: { Authorization: `Bearer ${data.token}` },
                        body: JSON.stringify(
                            {
                                iban: `SA${values?.IBAN}`,
                                nationalId: data.USER_ID
                            }
                        )
                    })
                    if (!verificationResult.ok) {
                        const errorResult = await verificationResult.json()
                        if (errorResult)
                            setIbanVerifyLoader(false)
                        switch (verificationResult.status) {
                            case 400:
                                // toast.error(`IBAN verification failed: ${(language.code === 'en' ? errorResult.error?.ERROR_Details_EN : errorResult.error?.ERROR_Details_AR) || errorResult.error?.message}`)

                                toast.error(`IBAN verification failed: ${errorResult.error?.message}`)
                                break;
                            case 429:
                                // toast.error(`${language.code === 'en' ? errorResult.error?.ERROR_Details_EN : errorResult.error?.ERROR_Details_AR || errorResult.error.message}`)
                                toast.error(`IBAN verification failed: ${errorResult.error?.message}`)
                                break;
                            case 500:
                                // toast.error(`IBAN verification failed: ${language.code === 'en' ? errorResult.error?.ERROR_Details_EN : errorResult.error?.ERROR_Details_AR || errorResult.error?.message}`)
                                toast.error(`IBAN verification failed: ${errorResult.error?.message}`)
                                break;
                            default:
                                break;
                        }
                        return
                    }
                    const response = await verificationResult.json()
                    if (response?.iban_verification && !response?.error?.message) {
                        setIbanVerifyLoader(false)
                        toast.success(translate("VALIDATION.IBAN_VAL_SUCCESS"))
                    }
                    else {
                        setIbanVerifyLoader(false)
                        toast.error(translate("VALIDATION.IBAN_VAL_FAILED"))
                        return
                    }
                } catch (error) {
                    setIbanVerifyLoader(false)
                    toast.error(translate("VALIDATION.IBAN_VAL_FAILED"))
                    return
                }
            }

            const res = await createNewApp({
                id: String(user?.IDB_USR_ID),
                idNumber: String(user?.USER_ID),
                idType: String(user?.USER_ID)[0] === "1" ? "NID" : "Q",
            }).unwrap();
            if (res?.query) {
                handleUploadDocuments(fileList, res?.query);
                productAppSubmit(values, res?.query, String(user?.IDB_USR_ID));
            }
        } catch (ex) {
            console.log("Error in create application", ex);
            toast.error("Error in creating application");
        }
    }

    const handleUploadDocuments = async (files, appId) => {
        setIsUploading(true);
        let updatedDocumentDetails = [...files];
        let allSuccess = true;
        await Promise.all(
            fileList.map(async (file, index) => {
                const formData = new FormData();
                formData.append("document", file);
                formData.append("appId", appId);
                const data = JSON.parse(localStorage.getItem("@@TAMWEEL_USER"));

                try {
                    await axios.post(`${env.API_ENDPOINT}app/upload-document`, formData, {
                        headers: {
                            Authorization: `Bearer ${data.token}`,
                        },
                    });
                    // Remove the file from the state after successful upload
                    updatedDocumentDetails.splice(index, 1);
                } catch (err) {
                    allSuccess = false;
                    toast.error("Failed to upload file.");
                }
            })
        )
        setIsUploading(false)
        // if (allSuccess) {
        //     toast.success("Application Created Successfully");
        //     navigate(appRoute(routes.HOME));
        // }
    }

    const beforeUpload = (file) => {
        const isJpgOrPngOrPdf =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "application/pdf";
        if (!isJpgOrPngOrPdf) {
            toast.error(translate("SETTINGS.ERROR_FILE_TYPE"));
            return true;
        }

        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
            toast.error(translate("SETTINGS.ERROR_FILE_SIZE_3MB"));
            return true;
        }

        const fileName = file.name;
        const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
        if (multipleExtensionsPattern.test(fileName)) {
            toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
            return true;
        }
        const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;

        if (invalidFileNamePattern.test(fileName)) {
            toast.error(translate("SETTINGS.ERROR_FILE_MULTIPLE_EXT"));
            return true;
        }

        if (fileName.toLowerCase().includes('contract')) {
            toast.error(translate("SETTINGS.ERROR_FILE_NAME_CONTRACT"));
            return true
        }
        setUploadFile(file)
        return false;
    };

    const validateFile = (file) => {
        const isValidType =
            file.type === "image/jpeg" ||
            file.type === "image/png" ||
            file.type === "image/jpg" ||
            file.type === "application/pdf";

        if (!isValidType) {
            return false;
        }

        const isUnder3MB = file.size / 1024 / 1024 < 3;
        if (!isUnder3MB) {
            return false;
        }

        const fileName = file.name;
        const multipleExtensionsPattern = /(\.[^.\s]{2,4}){2,}$/;
        if (multipleExtensionsPattern.test(fileName)) {
            return false;
        }

        const invalidFileNamePattern = /^[^.]+\.[^.]+\..+\.[^.]+$/;
        if (invalidFileNamePattern.test(fileName)) {
            return false;
        }

        if (fileName.toLowerCase().includes("contract")) {
            return false;
        }

        return true; // File is valid
    };

    const dragAndDropProps = {
        name: 'file',
        multiple: true,
        maxCount: 3,
        accept: "image/png,image/jpeg,image/jpg,application/pdf",
        beforeUpload,
        fileList,
        onChange(info) {
            if (info.file.status === 'error' || info.file.status === 'removed') {
                setFileList(prev => prev.filter(i => i.uid !== info.file.uid))
                return
            }
            const isValid = validateFile(info.file);
            if (isValid) {
                setFileList([...fileList, info.file])
                // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: [...fileList, info.file] });
            }
        },
        onDrop(e) {
            setFileList([e.dataTransfer.files])
        },
    };

    const handleRemove = (e) => {
        let updateFiles = fileList.filter(i => i.uid !== e.uid)
        // console.log('hi', updateFiles)
        // dispatch({ type: PATCH_DOCUMENT_DETAILS, payload: updateFiles });
        setFileList(prev => prev.filter(i => i.uid !== e.uid));
        setUploadFile(null)
    }

    const schemaFields = useMemo(
        () => {
            let hideRequestedLoanAmount = false;

            if (id === '1') { //ijarah
                hideRequestedLoanAmount = true;
                return autoLeaseSchema({
                    hideRequestedLoanAmount: hideRequestedLoanAmount,
                    tenureOptions,
                    manufacturerList,
                    modelList,
                    modelTypeList,
                    dealerList,
                    colorList,
                    conditionList,
                    yearList,
                })

            }
            else if (id === '2') { //tawarruq
                return personalFinanceSchema({
                    hideRequestedLoanAmount: hideRequestedLoanAmount,
                    tenureOptions,
                })
            }
        },
        [tenureOptions, manufacturerList, modelList, modelTypeList, dealerList, colorList, conditionList, yearList, loanReasonsOptions]
    );

    const ProductCards = (product) => {
        return (
            <div
                className="w-full max-w-[450px] max-h[250px] overflow-hidden"
            >
                <div key={product.id} className="bg-[#E6F1F2] rounded-lg overflow-hidden flex flex-row">
                    <div className="p-6 flex flex-col justify-between flex-1">
                        <div>
                            <h3 className="text-[#1F225B] text-xl md:text-2xl font-light mb-2">{product.title}</h3>
                            <p className="text-[#8E9196] text-sm md:text-base mb-4">{translate(product.description)}</p>
                        </div>
                    </div>
                    <div className="md:w-2/5 sm:w-2/5 w-1/2">
                        <img src={product.image} alt={product.id} className="w-full h-full object-cover" />
                    </div>
                </div>

            </div>
        )
    }

    const autoLeasingCardDetails = (product) => {
        return (
            <div
                bordered={false}
                className="bg-transparent shadow-none rounded-none border-none outline-none"
                style={{
                    width: '100%',
                    maxWidth: "550px",
                    minHeight: "250px", boxShadow: "none", // Remove shadow
                    border: "none",    // Remove border
                    borderRadius: "0", // Remove border-radius
                    outline: "none",
                    padding: "0"
                    // direction: 'ltr'

                }}
            >
                <p className="text-[#878787] mt-3 text-base md:text-lg font-light text-start mb-2">{translate(product.subDescription)}</p>
                <ul className="mt-3">
                    {[
                        translate('PRODUCTS.AUTO_PT1'),
                        translate('PRODUCTS.AUTO_PT2'),
                        // <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                        //     {isArabic ?
                        //         <span className="break-words">
                        //             <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate("VOUCHERS.STARTS_FROM")} {translate('VOUCHERS.FIVE_THOUSAND')}
                        //         </span>
                        //         :
                        //         <span className="break-words">
                        //             {translate("VOUCHERS.STARTS_FROM")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_THOUSAND')}
                        //         </span>}
                        // </li>,
                        translate("PRODUCTS.AUTO_PT3"),
                        translate("PRODUCTS.AUTO_PT4"),
                        translate("PRODUCTS.AUTO_PT5"),
                        translate("PRODUCTS.AUTO_PT6"),
                        translate("PRODUCTS.AUTO_PT7"),
                        translate("PRODUCTS.AUTO_PT8"),
                    ].map((text, index) => (
                        <li className="flex mb-4 gap-2" key={index}>
                            <span className="flex-shrink-0">
                                <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                            </span>
                            <span className="text-sm break-words">{text}</span>
                        </li>
                    ))}
                </ul>
                {/* <Button onClick={() => handleClick('1')} className="mt-4 bg-secondary border-none text-black font-semibold hover:!text-white hover:!bg-primary">
                    Select
                </Button> */}
                {/* <div className="mt-4">
                    <label className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            className="form-checkbox border border-gray-400 w-10"
                            checked={termsChecked}
                            onChange={(e) => setTermsChecked(e.target.checked)}
                        />
                        <span className="text-gray-700 text-xs">{translate("TERMS_AND_CONDITIONS")}</span>
                    </label>
                </div> */}
            </div >
        )
    }

    const personalFinanaceCardDetails = (product) => {
        return (
            <div
                bordered={false}
                className="bg-transparent shadow-none rounded-none border-none outline-none p-0"
                style={{
                    width: '100%',
                    maxWidth: "550px",
                    minHeight: "250px", boxShadow: "none", // Remove shadow
                    border: "none",    // Remove border
                    borderRadius: "0", // Remove border-radius
                    outline: "none",
                    padding: "0"
                    // direction:'ltr'
                }}
            >
                <p className="text-[#878787] mt-3 text-base md:text-lg font-light text-start mb-3">{translate(product.subDescription)}</p>
                <ul className="mt-4">
                    {[
                        translate('PRODUCTS.PRSNL_PT1'),
                        translate('PRODUCTS.PRSNL_PT2'),
                        // <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                        //     {isArabic ?
                        //         <span className="break-words">
                        //             <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate("VOUCHERS.STARTS_FROM")} {translate('VOUCHERS.FIVE_THOUSAND')}
                        //         </span>
                        //         :
                        //         <span className="break-words">
                        //             {translate("VOUCHERS.STARTS_FROM")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_THOUSAND')}
                        //         </span>}
                        // </li>,
                        translate("PRODUCTS.PRSNL_PT3"),
                        translate("PRODUCTS.PRSNL_PT4"),
                        translate("PRODUCTS.PRSNL_PT5"),
                        translate("PRODUCTS.PRSNL_PT6"),
                        translate("PRODUCTS.PRSNL_PT7"),
                        // translate("PRODUCTS.AUTO_PT8"),
                        // <li className="flex items-center" key="riyal-price"> {/* Added flex and items-center to this li */}
                        //     {isArabic ?
                        //         <span className="break-words">
                        //             {translate("VOUCHERS.MAX_LIMIT")} {translate('VOUCHERS.FIVE_HUNDRED_THOUSAND')} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" />
                        //         </span> :
                        //         <span className="break-words">
                        //             {translate("VOUCHERS.MAX_LIMIT")} <img src={SaudiRiyal} alt="riyal" className="w-3 h-4 inline-block" /> {translate('VOUCHERS.FIVE_HUNDRED_THOUSAND')}
                        //         </span>
                        //     }
                        // </li>,
                        // translate('VOUCHERS.SHERI_PT2'),
                    ].map((text, index) => (
                        <li className="flex gap-2 mb-4" key={index}>
                            <span className="flex-shrink-0">
                                <img src={Arrow} alt="checkmark" className="w-6 h-6" />
                            </span>
                            <span className="text-sm break-words">{text}</span>
                        </li>
                    ))}
                </ul>
                {/* <Button onClick={() => handleClick('2')} className="mt-4 bg-secondary border-none text-black font-semibold hover:!text-white hover:!bg-primary">
                    Select
                </Button> */}
                {/* <div className="mt-6">
                    <label className="flex items-center gap-2 mt-2">
                        <input
                            type="checkbox"
                            className="form-checkbox border border-gray-400 w-5 h-5 rounded-full"
                            checked={termsChecked}
                            onChange={(e) => setTermsChecked(e.target.checked)}
                        />
                        <span className="text-gray-700 text-sm">{translate("TERMS_AND_CONDITIONS")}</span>
                    </label>
                </div> */}
            </div>
        )
    }

    return (
        <div className="rounded-xl mb-4 px-4 py-4 bg-white shadow-lg">
            <div className="p-5">
                {/* <Button onClick={() => navigate(-1)}>{translate("Back")}</Button> */}
                <BackButton onClick={() => navigate(-1)} />

                <Row gutter={[16, 16]} className="pt-4">
                    {/* Card Section */}
                    <Col xs={24} md={10}>
                        {id == '1' ? ProductCards(autoLeaseDetails) : ProductCards(personalFinanceDetails)}
                        {id === "1" ? autoLeasingCardDetails(autoLeaseDetails) : personalFinanaceCardDetails(personalFinanceDetails)}
                    </Col>

                    {/* Form Section */}
                    <Col xs={24} md={14}>
                        <Formik
                            innerRef={formikRef}
                            enableReinitialize={true}
                            validateOnChange={true}
                            validateOnMount={true}
                            initialValues={buildInitialValues(schemaFields)}
                            validationSchema={buildValidationSchema(schemaFields)}
                            onSubmit={(values) => ProductAppCreate(values)}
                        >
                            {(props) => (
                                <Form onFinish={() => props.handleSubmit()}>
                                    {TenureUpdater(props)}
                                    <Title level={5} style={{ color: '#030438' }}>
                                        {translate('VOUCHERS.FILL_FORM')}
                                    </Title>
                                    <div>
                                        <FormDrawer schema={{ fields: schemaFields }} />
                                    </div>
                                    <div className="my-4">
                                        <label className="block text-gray-600 font-medium mb-2">
                                            {translate("SETTINGS.DOCUMENT")}
                                        </label>
                                        <Dragger
                                            {...dragAndDropProps} onRemove={e => handleRemove(e)}
                                            className="!border-none">
                                            <UploadOutlined className="text-3xl text-teal-600 mb-2" />
                                            <p className="text-teal-600 font-medium">
                                                {translate("SETTINGS.DOCUMENTS_DRAG_DROP_HEADING")}
                                            </p>
                                            <Text type="secondary" className="text-xs">
                                                {translate("SETTINGS.DOCUMENTS_DRAG_DROP_TEXT")}
                                            </Text>
                                        </Dragger>
                                    </div>
                                    {/* <div className="mt-6">
                                        <label className="flex items-center gap-2 mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-checkbox border border-gray-400 w-5 h-5 rounded-full accent-primary"
                                                checked={termsChecked}
                                                onChange={(e) => setTermsChecked(e.target.checked)}
                                            />
                                            <Link onClick={showTermsModal} className="text-blue-950 text-sm underline">{translate("TERMS_AND_CONDITIONS")}</Link>
                                        </label>
                                    </div> */}
                                    <div className="flex justify-end mt-8">

                                        <Button disabled={!props.isValid} type="primary" htmlType="submit" className="mt-4 bg-primary border-none text-white font-semibold p-6 w-40" >
                                            {(isLoading || isUploading) ? <LoadingOutlined /> :
                                                translate("APPLY")}
                                        </Button>

                                    </div>

                                </Form>
                            )}
                        </Formik>
                    </Col>
                </Row>
            </div>

        </div>

    )
}

export default FinanceProducts;